/**
 * Formatea un CUIT argentino al formato XX-XXXXXXXX-X.
 *
 * La función acepta valores como string o number.
 * Primero elimina cualquier carácter que no sea numérico,
 * por ejemplo guiones, espacios o puntos.
 *
 * Ejemplos:
 * - "22222222222"     => "22-22222222-2"
 * - "22-22222222-2"   => "22-22222222-2"
 * - "22.222.222-2"    => "22-22222222-2"
 *
 * Si el valor está vacío, retorna "No ingresado".
 * Si el CUIT no tiene 11 dígitos, retorna el valor original.
 *
 * @param {string | number | null | undefined} cuit
 * CUIT recibido desde la base de datos o formulario.
 *
 * @returns {string}
 * CUIT formateado en formato argentino o el valor original si no es válido.
 */
export const formatearCUIT = (cuit) => {
    if (!cuit) return "No ingresado";

    const soloNumeros = String(cuit).replace(/\D/g, "");

    if (soloNumeros.length !== 11) return String(cuit);

    return `${soloNumeros.slice(0, 2)}-${soloNumeros.slice(2, 10)}-${soloNumeros.slice(10)}`;
};